import {
  Box,
  Chip,
  CircularProgress,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";
import ErrorBoundary from "../../../../components/Helpers/ErrorBoundary";
import { commonTableOptions } from "../../../../constants";
import { API_RESULT, API_VERSION } from "../../../../enums/common.enum";
import {
  handleError,
  amountConverter,
  parseAndFormateDateCredit,
} from "../../../../utils/common";
import { useParams } from "react-router-dom";
import { PieChart, Pie, Cell } from "recharts";
import { instance } from "../../../../utils/api";

const MerchantEmiCredits = ({
  data,
  setData,
  visitedTabs,
  updateVisitedTabs,
}: any) => {
  const [loading, setLoading] = useState(false);
  const tableData = Array.isArray(data) ? data : [];
  const params = useParams();
  //     status: "success",
  //     response: {
  //       location_id: "1002-1732-3288-5742",
  //       today_emi_amount: 5350.05,
  //       items: [
  //         {
  //           credit_usage_id: 12,
  //           supplier_id: "SUP12345",
  //           supplier_name: "MedPharma Pvt Ltd",
  //           invoice_id: "INV-2026-0001",
  //           invoice_date: "2026-01-01",
  //           tenure_days: 15,
  //           interest_rate_per_day: 0.07,
  //           outstanding_amount: 5350,
  //           status: "ACTIVE",
  //           emi_per_day: 356.67,
  //           total_payable: 5350,
  //           total_emi_paid: 0,
  //           total_emi_remaining: 15,
  //           today_emi_collection: 5350.05,
  //           emis: [
  //             {
  //               emi_id: 1,
  //               emi_date: "2026-01-02",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 2,
  //               emi_date: "2026-01-03",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 3,
  //               emi_date: "2026-01-04",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 4,
  //               emi_date: "2026-01-05",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 5,
  //               emi_date: "2026-01-06",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 6,
  //               emi_date: "2026-01-07",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 7,
  //               emi_date: "2026-01-08",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 8,
  //               emi_date: "2026-01-09",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 9,
  //               emi_date: "2026-01-10",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 10,
  //               emi_date: "2026-01-11",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 11,
  //               emi_date: "2026-01-12",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 12,
  //               emi_date: "2026-01-13",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 13,
  //               emi_date: "2026-01-14",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 14,
  //               emi_date: "2026-01-15",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //             {
  //               emi_id: 15,
  //               emi_date: "2026-01-16",
  //               emi_amount: 356.67,
  //               status: "PENDING",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   };

  const fetchTodayEmiData = async () => {
    let payload = {
      metric_type: "credits",
      location_id: params?.locationId,
    };
    setLoading(true);
    try {
      const result = await instance.post(
        `${API_VERSION.V2}/analytics/digital-payments/overview`,
        payload,
      );
      if (result?.data?.status === API_RESULT.SUCCESS) {
        updateVisitedTabs(4, "add");
        setData(result.data.response.items || []);
      }
    } catch (err) {
      handleError(err);
    } finally {
      setLoading(false);
    }
  };
  //     setLoading(true);

  //     try {
  //       // simulate API delay (optional)
  //       setTimeout(() => {
  //         updateVisitedTabs(4, "add");
  //         setData(MOCK_EMI_DATA.response.items);
  //         setLoading(false);
  //       }, 500);
  //     } catch (err) {
  //       handleError(err);
  //       setLoading(false);
  //     }
  //   };

  useEffect(() => {
    if (!visitedTabs.includes(4)) {
      fetchTodayEmiData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const EmiProgressChart = ({ row }: any) => {
    const paid = Number(row.total_emi_paid) || 0;
    const remaining = Number(row.total_emi_remaining) || 0;

    const chartData = [
      { name: "Paid", value: paid, color: "#2F855A" },
      { name: "Remaining", value: remaining, color: "#ED8936" },
    ].filter((d) => d.value > 0);

    return (
      <PieChart width={80} height={80}>
        <Pie
          data={chartData}
          cx="50%"
          cy="50%"
          innerRadius={12}
          outerRadius={22}
          dataKey="value"
          isAnimationActive={false}
        >
          {chartData.map((entry, index) => (
            <Cell key={index} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
    );
  };

  const cols: any = [
    {
      name: "invoice_id",
      label: "Invoice",
      options: {
        filter: false,
        customBodyRender: (value: any, tableMeta: any) => {
          const row = data[tableMeta.rowIndex];
          return (
            <Box>
              <Typography fontWeight={600}>{value}</Typography>
              <Typography variant="caption" color="text.secondary">
                {parseAndFormateDateCredit(row.invoice_date)}
              </Typography>
            </Box>
          );
        },
      },
    },
    {
      name: "supplier_name",
      label: "Supplier",
    },
    {
      name: "tenure_days",
      label: "Tenure",
      options: {
        filter: false,
        customBodyRender: (value: any, tableMeta: any) => {
          const row = data[tableMeta.rowIndex];
          return (
            <Stack spacing={0.3}>
              <Typography variant="body2">{value} days</Typography>
              <Typography variant="caption" color="text.secondary">
                Interest: {row.interest_rate_per_day}% / day
              </Typography>
              <Typography variant="caption" color="text.secondary">
                EMI / Day: ₹ {row.emi_per_day}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Remaining: {row.total_emi_remaining}
              </Typography>
            </Stack>
          );
        },
      },
    },
    {
      name: "outstanding_amount",
      label: "Outstanding",
      options: {
        filter: false,
        customBodyRender: (value: number) => (
          <Typography fontWeight={600}>₹ {value}</Typography>
        ),
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        customBodyRender: (value: any) => {
          return (
            <>
              {value === "CLOSED" ? (
                <Chip
                  size="small"
                  label="CLOSED"
                  sx={{ backgroundColor: "#FBD38D", padding: "6px" }}
                />
              ) : value === "ACTIVE" ? (
                <Chip
                  size="small"
                  label="ACTIVE"
                  sx={{ backgroundColor: "#C6F6D5", padding: "6px" }}
                />
              ) : (
                <Chip
                  size="small"
                  label={value?.toUpperCase()}
                  sx={{
                    backgroundColor: "#C53030",
                    color: "#FFF",
                    padding: "6px",
                  }}
                />
              )}
            </>
          );
        },
      },
    },
    {
      name: "emi_progress",
      label: "EMI Progress",
      options: {
        sort: false,
        filter: false,
        customBodyRenderLite: (dataIndex: number) => {
          const row = tableData[dataIndex];
          if (!row) return null;
          return (
            <Tooltip
              title={
                <>
                  Paid EMIs: {row.total_emi_paid}
                  <br />
                  Remaining EMIs: {row.total_emi_remaining}
                  <br />
                  Outstanding: ₹ {row.outstanding_amount}
                </>
              }
            >
              <Box display="flex" justifyContent="center">
                <EmiProgressChart row={row} />
              </Box>
            </Tooltip>
          );
        },
      },
    },
  ];

  const options: any = {
    textLabels: {
      body: {
        noMatch: loading ? (
          <CircularProgress sx={{ color: "#0058ff" }} />
        ) : (
          "Sorry, there is no matching data to display"
        ),
      },
    },
    ...commonTableOptions,
    searchPlaceholder: "Invoice ID/Supplier Name",
    rowsPerPageOptions: [10, 50, 100, 200],
    rowsPerPage: 10,
    expandableRows: true,
    expandableRowsHeader: false,
    expandableRowsOnClick: true,
    renderExpandableRow: (rowData: any, rowMeta: any) => {
      const row = data[rowMeta.dataIndex];

      return (
        <tr>
          <td colSpan={rowData.length} style={{ padding: 0 }}>
            <Box
              sx={{
                p: 2,
                backgroundColor: "#fafafa",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box width="100%">
                <Typography fontWeight={600} mb={1}>
                  EMI Schedule
                </Typography>

                <Box
                  sx={{
                    backgroundColor: "#fff",
                    border: "1px solid #e0e0e0",
                    borderRadius: 1,
                    width: "100%",
                    maxWidth: "100%",
                  }}
                >
                  <table width="100%">
                    <thead>
                      <tr style={{ background: "#f5f5f5" }}>
                        <Th>#</Th>
                        <Th>EMI Date</Th>
                        <Th align="right">Amount</Th>
                        <Th>Status</Th>
                      </tr>
                    </thead>
                    <tbody>
                      {row.emis?.map((emi: any, index: number) => (
                        <tr key={emi.emi_id}>
                          <Td>{index + 1}</Td>
                          <Td>{parseAndFormateDateCredit(emi.emi_date)}</Td>
                          <Td align="right">₹ {emi.emi_amount}</Td>
                          <Td>
                            <Chip
                              size="small"
                              label={emi.status}
                              sx={{
                                backgroundColor:
                                  emi.status === "PAID" ? "#C6F6D5" : "#FBD38D",
                              }}
                            />
                          </Td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </Box>
              </Box>
            </Box>
          </td>
        </tr>
      );
    },

    page: 0,
  };

  const Th = ({ children, align = "left" }: any) => (
    <th
      style={{
        padding: "10px",
        fontSize: "12px",
        fontWeight: 600,
        textAlign: align,
      }}
    >
      {children}
    </th>
  );

  const Td = ({ children, align = "left" }: any) => (
    <td
      style={{
        padding: "10px",
        fontSize: "13px",
        borderTop: "1px solid #eee",
        textAlign: align,
      }}
    >
      {children}
    </td>
  );

  return (
    <>
      <Box
        mb={3}
        gap={4}
        display="flex"
        flexDirection={{ xs: "column", md: "row" }}
        justifyContent={{ xs: "flex-start", md: "flex-end" }}
        alignItems="flex-end"
      >
        <Box
          width={{ xs: "100%", md: "30%" }}
          sx={{
            boxShadow: "0 0 .25rem rgba(0,0,0,.075)",
            padding: "10px",
            borderRadius: "5px",
            display: "flex",
          }}
        >
          <Box sx={{ width: "50%", textAlign: "center" }} pt={1}>
            <Typography
              sx={{
                fontSize: "12px !important",
              }}
            >
              Count
            </Typography>
            <Typography variant="h6" sx={{ fontSize: "20px !important" }}>
              <strong>{data?.length > 0 ? data?.length : 0}</strong>
            </Typography>
          </Box>
          <Box
            sx={{
              width: "50%",
              borderLeft: "1px solid #e7e7e7",
              textAlign: "center",
            }}
            pt={1}
          >
            <Typography
              sx={{
                fontSize: "12px !important",
              }}
            >
              Amount
            </Typography>
            <Typography variant="h6" sx={{ fontSize: "20px !important" }}>
              &#8377;&nbsp;
              {amountConverter(
                tableData.reduce(
                  (acc: number, curr: any) =>
                    acc + Number(curr.outstanding_amount || 0),
                  0,
                ),
              )}
            </Typography>
          </Box>
        </Box>
      </Box>
      <ErrorBoundary>
        <MUIDataTable
          title=""
          data={tableData}
          columns={cols}
          options={options}
        />
      </ErrorBoundary>
    </>
  );
};

export default MerchantEmiCredits;
